// //const _ = require("lodash");

// const apis = [
//   rest.get("https://www.daehansarang.org/daehanvodlist", (req, res, ctx) => {
//     // const errorCode = req.url.searchParams.get("error_code");
//     // if (errorCode) {
//     //   return res(ctx.status(errorCode));
//     // }

//     const keyword = _.trim(req.url.searchParams.get("keyword"));
//     const cat = _.trim(req.url.searchParams.get("cat"));

//     const data = _.filter(youtubeList.items, function(o) {
//       if(keyword == "")
//         return true;

//       const idx = String(o.title).search(new RegExp(keyword, "i"));
//       return idx >= 0;
//     });

//     return res(
//       ctx.status(200), // rest api status code
//       ctx.delay(500), // api delay time
//       ctx.json(
//         {
//           total_rows: data.length,
//           cat: cat,
//           items: _.take(data, 30)
//         }
//         //_.take(data, 30)
//       )
//     );
//   })
// ];

// export default apis;

// setting msw
//export const worker = setupWorker(...apis);

////////////////////////////////////

import axios from 'axios';

export default axios.create({
  baseURL: 'https://www.daehansarang.org',
  params: {
    cat: null,
    keyword: '',
    //maxResults: 50
  }
})

